import { MAX_BREAKPOINT } from './breakpointsValues.js';

const JOURNEY_PAGE_SPACING_BY_STYLE_GUIDE = 60;
const GENERAL_LAYOUT_SPACING = 15;

const JOURNEY_PAGE = {
  PROVIDER_WRAPPER_BORDER_WIDTH: 1,
  LEFT_SPACING: JOURNEY_PAGE_SPACING_BY_STYLE_GUIDE - GENERAL_LAYOUT_SPACING,
  RIGHT_SPACING: JOURNEY_PAGE_SPACING_BY_STYLE_GUIDE - GENERAL_LAYOUT_SPACING,
  HEADER: {
    TOP_HALF: 42,
    BOTTOM_HALF: 40,
    PADDINGS: {
      VW: {
        TOP: `${(50 / MAX_BREAKPOINT) * 100}vw`,
      },
    },
  },
  PANEL: {
    TABS_HEIGHT: 42,
    MARGINS: {
      VW: {
        TOP: `${(40 / MAX_BREAKPOINT) * 100}vw`,
        BOTTOM: `${(20 / MAX_BREAKPOINT) * 100}vw`,
      },
    },
  },
  DRAGGABLE_ICON: {
    SQUARE: {
      LENGTH: 52,
      IMAGE: {
        LENGTH: 42,
      },
    },
    CIRCLE: {
      RADIUS: 26,
      IMAGE: {
        RADIUS: 16,
      },
    },
  },
  DRAG_ELEMENT: {
    CIRCLE: {
      RADIUS: 28,
      IMAGE: {
        RADIUS: 16,
      },
    },
    SQUARE: {
      LENGTH: 52,
      IMAGE: {
        LENGTH: 42,
      },
    },
  },
  ARROW_MARKER_LENGTH: 6,
  ARROW_STROKE_WIDTH: 2,
};

export default JOURNEY_PAGE;
